import {createQueryKeys} from '@lukemorales/query-key-factory'
import {isNil, omitBy} from 'lodash-es'
import {api} from 'api'
import type {FullSearchProps} from 'api/parts/search'
import {getFullSearchQueryParams} from 'api/parts/search'
import type {KeyTuple} from 'types/util'

function getQueryKey(props: FullSearchProps): KeyTuple {
  const queryParams = getFullSearchQueryParams(props)
  return Object.entries(omitBy(queryParams, isNil)) as KeyTuple
}

export const search = createQueryKeys('search', {
  fullSearch: (props: FullSearchProps) => ({
    queryKey: getQueryKey(props),
    queryFn: () => api.search.fullSearch(props),
  }),
})
